import React from 'react';
import { Link } from 'react-router-dom';

const CancellationAndRefundPolicy = () => {
  return (
    <div>
      <link
        href="https://unpkg.com/tailwindcss@2.2.19/dist/tailwind.min.css"
        rel="stylesheet"
      ></link>

      <div className="max-w-5xl mx-auto px-4 py-10 text-gray-800">
        <div className="bg-white border border-gray-300 rounded-xl p-6 shadow-lg">

          {/* Heading */}
          <h1 className="text-2xl sm:text-3xl font-bold text-blue-800 mb-6 text-center">
            BookTrip4Me Cancellation & Refund Policy
          </h1>

          {/* Bullet Points */}
          <ol className="list-decimal space-y-3 pl-6 text-sm sm:text-base">
            <li>
              <strong>Non-Refundable Tickets:</strong> All tickets are
              non-refundable and non-transferable unless otherwise specified.
            </li>
            <li>
              <strong>Service Fees:</strong> All fees associated with travel
              management services—including reservations, modifications, and
              cancellations—are non-refundable.
            </li>
            <li>
              <strong>Provider Terms:</strong> The customer consents to the
              terms and conditions set forth by the airline, hotel, car rental,
              and cruise providers.
            </li>
            <li>
              <strong>Cancellation and Amendment Charges:</strong> Any
              cancellation or amendment charges or fare differences imposed by
              service providers must be paid by the customer.
            </li>
            <li>
              <strong>Review of Provider Policies:</strong> Customers are urged
              to review all fee, penalty, and policy provisions related to
              alterations and cancellations.
            </li>
            <li>
              <strong>Unused Tickets:</strong> Any unused tickets after the
              scheduled travel date/time will be void as per the provider’s
              regulations.
            </li>
          </ol>

          {/* Additional Notice */}
          <div className="mt-8 text-sm sm:text-base leading-relaxed">
            <p className="mb-3">
              <strong>Important:</strong> Your e-tickets will be sent via email
              within 24 hours, unless delayed by the airline. Fares are not
              guaranteed until paid and ticketed. If any restrictions or changes
              apply, we will notify you by email or phone.
            </p>

            <p className="mb-3">
              Any request to modify the itinerary after ticket issuance may
              incur penalties, fare differences, and additional fees.
            </p>

            <p>
              <strong>Note:</strong> As agreed, your credit card may be billed
              in multiple split charges not exceeding the total amount. All
              transaction service fees are 100% non-refundable.
            </p>
          </div>
        </div>

        {/* Button */}
        <div className="mt-8 text-center">
          <Link
            to="/paymentPolicy"
            className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 
                     hover:from-blue-700 hover:to-purple-700 
                     text-white font-semibold py-2.5 px-6 rounded-xl 
                     shadow-md transition-all duration-300"
          >
            💳 View Payment Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CancellationAndRefundPolicy;
